declare var $;

/**
 * Fetches the DOM content for the cancel order section and binds controls if needed.
 */
export class CancelOrderSection {
    /**
     * @var {string} sales_id;
     */
    sales_id: string;
    modal: HTMLCollectionOf<Element>;

    /**
     * Fetch the DOM content and bind the controls.
     *
     * @param {string} sales_id of the order.
     * @returns {CancelOrderSection} with request pending.
     */
    constructor(sales_id:string) {
        this.sales_id = sales_id;
        this.async_init();
    }

    /**
     * Fetch the DOM content.
     *
     * @returns {void}
     */
    async_init() : void {
        $.ceAjax('request', 'index.php?dispatch=tv_customer_orders.cancel_status', {
            method: 'POST',
            cache: false,
            hidden: true,
            result_ids: 'js-order-details-cancel-section',
            callback: this.async_init_callback.bind(this),
            data: { sales_id: this.sales_id }
        });
    }

    /**
     * When the DOM content is returned bind the cancel button if needed.
     *
     * @returns {void}
     */
    async_init_callback() : void {
        const cancel_button = document.getElementById('js-order-cancel-button');
        const dropdown = <HTMLSelectElement>document.getElementById('cancel_dropdown');

        if (cancel_button) {
            cancel_button.addEventListener('click', this.cancel.bind(this), false);
            cancel_button.classList.remove('tv-button__disabled');
        }

        if (dropdown) {
            dropdown.addEventListener('change', function() {
                if (dropdown.value === "other") {
                    document.getElementById('cancel_comment_label').classList.add('cm-required');   
                    (<HTMLInputElement> document.getElementById('cancel_comment')).required = true;
                } else {
                    document.getElementById('cancel_comment_label').classList.remove('cm-required');   
                    (<HTMLInputElement> document.getElementById('cancel_comment')).required = false;
                }  
            })

            dropdown.disabled = false;
        }
        
    }

    /**
     * Event listener to handle cancel order button click.  Sends ajax request to cancel order.
     *
     * @listens click
     * @param {Event} e from click event.
     * @returns {void}
     */
    cancel(e: Event) :void {
        const cancel_order_form = <HTMLFormElement>document.getElementById('cancel_order_form');

        if (!cancel_order_form.checkValidity()) {
            return;
        }
        
        e.stopPropagation();
        e.preventDefault();

        const message = (<HTMLInputElement>document.getElementById('cancel_comment')).value.trim();
        const select_reason = <HTMLSelectElement>document.getElementById('cancel_dropdown');
        const select_reason_value = select_reason.options[select_reason.selectedIndex].value;
            
        // Send Ajax request to cancel order and submit data 
        $.ceAjax('request', 'index.php?dispatch=tv_customer_orders.cancel_order', {
            method: 'POST',
            full_render: true,
            cache: false,
            data: { 
                sales_id: this.sales_id,
                cancel_reason: select_reason_value,
                cancel_feedback: message
            },
            callback: this.handle_response.bind(this)
        });

        //Close the modal.
        $.ceDialog('get_last').ceDialog('close');

    }

    /**
     * Displays the success or error notification and hides the cancel button.
     *
     * @param {object} response object that holds the success/error notification information.
     * @returns {void}
     */
    handle_response(response: object) {
        const notification = response['notification'];
        const cancel_button = document.getElementById('js-order-cancel-button-modal')
        const notification_container = document.getElementById('js-cancel-notification-container');

        if (notification.type === 'E') {
            notification_container.classList.add('alert-error');
        } else {
            notification_container.classList.add('alert-success');
        }

        const notification_title = document.getElementById('js-cancel-notification-title');
        notification_title.innerHTML = notification.title;

        const notification_message = document.getElementById('js-cancel-notification-message');
        notification_message.innerHTML = notification.message;

        notification_container.classList.remove('hidden');

        cancel_button.classList.add('hidden');

        // Reload page to properly display the cancelled order info
        location.reload();
    }
}
